interface RecipientNameContainer {
  recipientName: string;
  isRecipientMissing?: boolean;
}

export const getRecipientName = ({ recipientName, isRecipientMissing }: RecipientNameContainer): string => {
  if (!isRecipientMissing) {
    return recipientName;
  }

  return recipientName ? `${recipientName} (deleted)` : "(deleted)";
};
